module.exports = __webpack_public_path__ + "img/avatar.ed54c804.png";